import {useMemo} from 'react';

const baseTheme = {
	top: {
		height: '50px',
	},
	sort: {
		height: '44px',
	},
	header: {
		height: '90px',
	},
    footer: {
        height: '56px',
    },
	white_0: '#fff',
	blue_1: '#001b2a',
	pink_1: '#ffecef',
	pink_2: '#d7002412',
	yellow_1: '#fff0cb',
	yellow_2: '#f0ca7f36',
	link_1: '#00f',
	link_2: '#369',
};

const variants = {
	light: {
		color: {
			name: 'light',
		},
		form: {
			inputBorder: '1px',
		},
		popup: {
			backgroundColor: '#fff',
			color: '#151b21',
			borderBottom: '1px',
		},
		menu: {
			backgroundColor: '#fff',
			color: '#1d1d1d',
			button: '#efefef',
			buttonColor: '#1d1d1d',
		},
		post: {
			primary: '#313131',
			cardBorderTop: '7px',
			cardBorderBottom: '0px',
		},
		main: {
			color: '#444',
			backgroundColor: '#f9f9f9',
		},
		container: {
			backgroundColor: '#eeeeef',
		},
		content: {
			backgroundColor: '#fff',
			border: '#e7e7e7',
		},
		sort: {
			color: 'rgb(149 155 165)',
			active: '#151b21',
			backgroundColor: '#fff',
			borderBottom: '1px',
		},
		footer: {
			color: '#444',
			backgroundColor: '#fff',
			border: '#e7e7e7',
			borderTop: '1px',
			secondary: '#eeeeef',
		},
		sidebar: {
			color: '#1d1d1d',
			backgroundColor: '#fff',
			secondary: '#eaeaea',
		},
		control: {
			color: '#000',
			backgroundColor: '#f7f7f7',
		},
		label: {
			color: '#444',
		},
		skeleton: {
			color: '#eee',
			highlightColor: '#f5f5f5',
		},
	},
	dark: {
		color: {
			name: 'dark',
		},
		form: {
			inputBorder: '0px',
		},
		popup: {
			backgroundColor: '#002031',
			color: '#fff',
			borderBottom: '0px',
		},
		menu: {
			backgroundColor: '#001824',
			color: '#f1f1f1',
			button: '#fff',
			buttonColor: '#151b21',
		},
		post: {
			primary: '#dedede',
			cardBorderTop: '0px',
			cardBorderBottom: '8px',
		},
		main: {
			color: '#fff',
			backgroundColor: '#000a10',
		},
		container: {
			backgroundColor: '#001824',
		},
		content: {
			backgroundColor: 'rgb(0 22 35)',
			border: '#000a10',
		},
		sort: {
			color: '#a9a9a9',
			active: '#fff',
			backgroundColor: 'linear-gradient(rgb(0, 27, 42) 0%, rgb(0 22 35) 100%)',
			borderBottom: '0px',
		},
		footer: {
			color: '#d7d7d7',
			backgroundColor: '#001b2a',
			border: '#002031',
			borderTop: '0px',
			secondary: '#00121b',
		},
		sidebar: {
			color: '#d7d7d7',
			backgroundColor: '#002031',
			secondary: '#001c2a',
		},
		control: {
			color: '#f1f1f1',
			backgroundColor: 'rgb(30 30 30)',
		},
		label: {
			color: '#ddd',
		},
		skeleton: {
			color: '#00121d',
			highlightColor: '#000e15',
		},
		link_1: '#1978b0',
	},
};

function isObject(item) {
	return item && typeof item === 'object' && !Array.isArray(item);
}

const {hasOwnProperty} = Object.prototype;

function mergeDeep(left, right) {
	if (!isObject(left)) {
		return right;
	}
	if (!isObject(right)) {
		return left;
	}
	const result = {};
	for (const [key, value] of Object.entries(left)) {
		if (hasOwnProperty.call(right, key)) {
			result[key] = mergeDeep(value, right[key]);
		} else {
			result[key] = value;
		}
	}
	for (const [key, value] of Object.entries(right)) {
		if (!hasOwnProperty.call(left, key)) {
			result[key] = value;
		}
	}
	return result;
}

const getThemeVariant = (variant) => {
	const theme = mergeDeep(baseTheme, variants[variant || 'light']);
	theme.isSafari = (
		navigator.userAgent.indexOf('Safari') !== -1 &&
		navigator.userAgent.indexOf('Chrome') === -1
	);
	return theme;
}

const useTheme = (variant) => {
	return useMemo(() => getThemeVariant(variant), [variant]);
}

export default useTheme;
